module.exports = __webpack_public_path__ + "img/9.6s.fa124793.jpg";